module.exports = __webpack_public_path__ + "static/img/mapfre-logo.ed2f228.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mapfre-logo.png
// module id = 436
// module chunks = 6